<template>
    <span>
    <div class="protection-options__heading">
        <h3 class="protection-options__title">
            <input type="checkbox"  class="cross-box" :data-id="cross.id" :id="cross.id + 'check'" value="true" :data-cross="cross.combi" @click="crosssellingCheck(cross, productPrice, productName)">
            <label :for="cross.id + 'check'" class="fake-label combi-label">{{ productName }}</label>
        </h3>
        <div class="protection-options__payment">
            <span class="protection-options__new-price">nur {{ productPrice | replacePoint }}&nbsp;€ </span>
            <span class="protection-options__old-price"><s v-if="cross.cdiscount != 0">statt {{ orgPrice | replacePoint }}&nbsp;€</s> monatlich</span>
        </div>
        </div>
        <div class="protection-options__open-close open-close">
        <div class="open-close__opener">
            <span class="open-close__link">
            <span class="show-more" v-if="!openClose" @click="openClose = true">Mehr Informationen <span class="icon-down-arrow"></span></span>
            <span class="show-more less" v-if="openClose" @click="openClose = false">Weniger Informationen <span class="icon-down-arrow"></span></span>

            </span>
        </div>
        <div class="open-close__slide card__body" v-html="productInfo" v-if="openClose">
            <ul>
            </ul>
        </div>
        </div>

        <div class="
            protection-options__label
            protection-options__label--yellow
            " v-if="isSale">
         <span>Angebot</span> <span v-if="!is24">%</span>
        </div>
        </span>
</template>

<script>
export default ({
   model: {
        prop: 'lead',
        event: 'leademit'
    },
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        lead: {
            type: Object,
            default() {
                return {}
        }},
        cross: {
            type: Object,
            default() {
                return {}
        }},
      isSale: {
        type: Boolean,
        default() {
          return true
        }},
        type: {
            type: String,
            default() {
                return ''
        }}
    },
    data: () => ({
      productInfo: '',
      productName: '',
      productPrice: '',
      displayedPrice: '',
      orgPrice : '',
      breed_class_id: 0,
      openClose: false,
      radio: false,
      crossselling:false,
      is24: false,
      crossValue: false,
    }),
    mounted: function() {

        if (this.lead.productActive == 11 || this.lead.productActive == 16 || this.lead.productActive == 4) {
            this.is24 = true
        }

        let product = this.registry.productByID[this.cross.id]
        this.productInfo = product.upsellingtext

        this.productName = product.title
        let seconds = this.calcAgeInSeconds(this.lead.petbirthday)

        let matrix = this.getMatrix(this.lead, this.registry, this.cross.id);



        this.productPrice = parseFloat(this.calcPrice(matrix, seconds)).toFixed(2)

        if(this.cross.cdiscount != 0) {
            this.orgPrice = this.productPrice
            this.productPrice = (((this.productPrice - (this.cross.cdiscount / 12))*10) / 10).toFixed(2)
        }

        if (this.lead.crossselling === this.cross.id) {
          const checkboxes = document.querySelectorAll('[data-cross]');
          const activeCheckbox = Array.from(checkboxes).findIndex(checkbox => checkbox.dataset.id == this.cross.id);
          if (activeCheckbox > -1) {
            checkboxes[activeCheckbox].checked = true;
          }
          this.crosssellingCheck(this.cross, this.productPrice, this.productName)
        }


    },
    methods: {
        crosssellingCheck(cross, productPrice, productName) {
          this.$emit('crosssellingCheck', {cross, productPrice, productName})
        },
        crosssellingM(id) {
            const selected = document.querySelectorAll('[data-id]')
            for(let sel in selected) {
                if(typeof selected[sel].dataset != 'object' || selected[sel].dataset.id == id) {
                    continue;
                }
            }
        }

    }

})
</script>

<style>
div.open-close__slide.card__body ul{
    margin-top:15px;
}
div.open-close__slide.card__body ul li{
    margin-bottom:8px;
}
div.open-close__slide.card__body li::before {
    padding-bottom: 5px;
    padding-top: 0px;
    padding-left: 4px;
    padding-right: 2px;
}
.wrapper.checkbox label.checkbox {
    position:absolute;
    padding: 20px
}
.wrapper.checkbox label.checkbox span {
    display:inline-block;
    margin-left:8px;
}
.wrapper.checkbox {
    border-color:rgb(1, 78, 158)
}
.input-control .wrapper.checkbox {
    border-color:#014e9e;
}
.open-close__link .show-more {
    cursor:pointer;
}
.open-close__opener{
    margin-left:12px;
}
.protection-options .open-close__opener {
  margin-left:21px;
  padding-left: 0;
}
.protection-options .protection-options__heading {
  margin-bottom: 8px !important;
}
.protection-options .protection-options__label {
  z-index: 0;
  padding: 6px 24px 6px 24px;
  top: 0;
}
.less .icon-down-arrow {
    display:inline-block;
    -webkit-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
}
.combi-label {
    margin-left:7px;
    display:inline-block;

}
@media (max-width: 512px) {
  .combi-label {
      font-size:0.9em;
  }
}
@media (max-width: 472px) {
  .combi-label {
      font-size:0.85em;
  }
}
@media (max-width: 451px) {
  .combi-label {
      font-size:0.8em;
  }
}
h3.protection-options__title {
  display: flex;
  line-height: 16px !important;
}
</style>
